export const TRUNCATE_FILE_NAME_MAX_LENGTH = 36;
export const DEBOUNCE_DELAY = 300;
export const SEARCH_PLACEHOLDER = "Search Documents";
export const NA = "N/A";
export const ERROR_FETCHING_DOCUMENTS = "Unexpected error while loading document data";
